import { ProgressBar } from '@dreamtree-org/twreact-ui';

/**
 * Labelled horizontal bars composed from twreact ProgressBar, for ranked lists
 * that carry a per-row note (e.g. funnel steps with conversion %), which the
 * twreact charts don't render. Use '@dreamtree-org/twreact-ui/charts' for plots.
 *
 *   rows: [{ label, value, display?, hint? }]
 */
export default function BarList({ rows, max, format = (v) => v.toLocaleString('en-IN'), ariaLabel = 'Values' }) {
  const top = max ?? Math.max(1, ...rows.map((r) => r.value || 0));
  return (
    <ul className="space-y-3" aria-label={ariaLabel}>
      {rows.map((r) => (
        <li key={r.label} className="space-y-1">
          <div className="flex items-baseline justify-between gap-3 text-sm">
            <span className="min-w-0 truncate">{r.label}</span>
            <span className="font-medium tabular-nums shrink-0">
              {r.display ?? format(r.value)}
              {r.hint ? <span className="ml-1 text-xs font-normal opacity-60">{r.hint}</span> : null}
            </span>
          </div>
          <ProgressBar value={r.value || 0} max={top} size="sm" ariaLabel={`${r.label}: ${r.display ?? format(r.value)}`} />
        </li>
      ))}
    </ul>
  );
}
